import { render, staticRenderFns } from "./ws2-work-timeout.vue?vue&type=template&id=05692d1a"
import script from "./ws2-work-timeout.vue?vue&type=script&lang=js"
export * from "./ws2-work-timeout.vue?vue&type=script&lang=js"
import style0 from "./ws2-work-timeout.vue?vue&type=style&index=0&id=05692d1a&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports